/* eslint-disable import/extensions */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-restricted-syntax */
import React, { useEffect, useCallback, useMemo, useState } from 'react';
import { parse } from 'query-string';
import { useLocation, useHistory } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { SmlsAnimation } from '@smiles/smiles-ui-kit-react';
import { useAuth0 } from '@auth0/auth0-react';
import Axios from 'axios';
import jwt from 'jsonwebtoken';
import { useTranslation } from 'react-i18next';

import { fingerprint as b2eFingerprint, identity as b2eIdentity } from 'services/b2e/services';
import {
  generateTokenEmail,
  getPartnerToken,
  suspendedAccountHasSSR,
  getMemberInfo,
  getMember,
} from 'services/core/services';
import { Config, smilesEnv } from 'services/core/config';

import { LiferayLoginConfig62 } from 'utils/config.constants';
import { loginLiferay } from 'utils/liferay';
import { useLDVariants } from 'context/LaunchDarklyProvider';

const Callback: React.FC = () => {
  const JWT_COOKIE_NAME = process.env.REACT_APP_TOKEN_NAME || 'session-token';
  const CONV_ID_COOKIE_NAME = '_convid';
  const USER_ID_COOKIE_NAME = '_userid';
  const LOGIN_ENTRY_CHANNEL_COOKIE_NAME = '_loginEntryChannel';
  const ENTRY_PHONE_COOKIE_NAME = '_entryPhone';
  const SUB_ENV_COOKIE_NAME = '_subEnv';

  const { flags } = useLDVariants();
  const history = useHistory();
  const { isLoading } = useAuth0();
  const location = useLocation();
  const [partnerParams, setPartnerParams] = useState<any>();
  const [animationState, setAnimationState] = useState({ isLoading: false, isSuccess: false });
  const [onFinishAnimation, setOnFinishAnimation] = useState<() => void>();
  const [cookies, setCookie, removeCookie] = useCookies([
    JWT_COOKIE_NAME,
    CONV_ID_COOKIE_NAME,
    USER_ID_COOKIE_NAME,
    LOGIN_ENTRY_CHANNEL_COOKIE_NAME,
    ENTRY_PHONE_COOKIE_NAME,
    SUB_ENV_COOKIE_NAME,
  ]);
  const { t } = useTranslation('callback');
  const [message, setMessage] = useState({
    error: [],
    loading: [t('one_moment')],
    success: [t('ready')],
  });

  const traductionProduct = useMemo(
    () => ({
      'hoteis.smiles': 'smiles-hoteis',
      'staging.hoteis': 'smiles-hoteis',
      'ingresso.smiles': 'smiles-ingresso',
      'passeios.smiles': 'smiles-passeios',
      'demo.gl-tours': 'smiles-passeios',
      'cruzeiros.smiles': 'smiles-cruzeiros',
      'cruzeiros-hml.smiles': 'smiles-cruzeiros',
    }),
    [],
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimationState({ isLoading: true, isSuccess: true });
    }, 1050);

    return () => clearTimeout(timer);
  }, []);

  const defaultRedirect = useMemo(() => ['smiles-shopping', 'smiles-carros', 'smiles-atracoes'], []);

  const params = useMemo(() => parse(location.search), [location]);

  const prop = (obj: Record<string, string>, value: string) => {
    const keyList = Object.keys(obj).filter((key) => value.includes(key));
    if (keyList.length) {
      return obj[keyList[0]];
    }
    return undefined;
  };

  const sendToRedis = async (data: any) => {
    try {
      console.log('data to send to Redis : ', JSON.stringify(data));
      const postRedisUrl = `https://apigw-${smilesEnv}.smiles.com.br/loginwhats/v1/insertToken`;
      const resp = await Axios.post(postRedisUrl, data);
      console.log('response axios post on api : ', JSON.stringify(resp));
      return resp;
    } catch (e) {
      console.error('Error saving data to Redis: ', e);
    }
  };
  const sendToLoginSunco = async (data: any, subEnv: string, tokenJWT: string) => {
    const headers = {
      Authorization: `Bearer ${tokenJWT}`,
    };
    try {
      console.log('data to send to API Gateway Login Sunco : ', JSON.stringify(data));
      const postRedisUrl = `https://apigw${subEnv}.smiles.com.br/zendesk-msg/v1/sv/sunco/login`;
      const resp = await Axios.post(postRedisUrl, data, { headers });
      console.log('response axios post on api : ', JSON.stringify(resp));
      return resp;
    } catch (e) {
      console.error('Error sending data to API Gateway: ', e);
    }
  };

  const getProduct = useCallback(() => {
    if (params) {
      if (params.product) return params.product;
      if (params._58_redirect) {
        const traductionValue = prop(traductionProduct, params._58_redirect as string);
        if (traductionValue) {
          return traductionValue;
        }
        return params._58_redirect;
      }
      if (params.urlCallback) return params.urlCallback;
    }
    return null;
  }, [location]);

  useEffect(() => {
    const product = getProduct();
    if (product) {
      const defaultRedirectTrue = defaultRedirect.includes(product as string);
      setPartnerParams({
        product,
      });
    }
    if (location && location.state) {
      setPartnerParams(location.state);
    }
  }, [location]);

  const getMemberCobranded = async (): Promise<boolean> => {
    const { data: memberInfo } = await getMemberInfo();

    const memberValidate = {
      statusActive: memberInfo?.status === 'ACTIVE',
      partnerSourceAlias: Boolean(/CSA|CBB|CBR/.exec(memberInfo?.partnerSourceAlias)),
      confirmData: memberInfo?.confirmData,
      verifiedPhoneNumber: memberInfo?.verifiedPhoneNumber,
    };

    const isMemberCobranded = [
      memberValidate.statusActive,
      memberValidate.partnerSourceAlias,
      !memberValidate.verifiedPhoneNumber,
      !memberValidate.confirmData,
    ].every((item) => item);

    if (isMemberCobranded) {
      console.warn('customer is necessary confirm register');
      return true;
    }
    console.warn('customer is not necessary confirm register');
    return false;
  };

  const getMemberGolTerms = async (): Promise<boolean> => {
    const response = await getMember();

    return response.data?.acceptedGOLRegister === 'Y';
  };

  const redirectToFirstAccess = (): void => {
    let redirectUrl = `${window.location.origin}/validar/acesso`;

    if (params.ref) {
      redirectUrl = `${redirectUrl}?ref=${params.ref}`;
    } else if (decodeURI(partnerParams?.product as string).startsWith('/')) {
      redirectUrl = `${redirectUrl}?ref=${partnerParams.product}`;
    }

    window.location.href = redirectUrl;
  };

  useEffect(() => {
    (async () => {
      try {
        const token = cookies[JWT_COOKIE_NAME];
        const decoded = jwt.decode(token) as any;
        const apiMemberStatus = decoded?.['https://smiles.api/memberStatus'];
        const flagFirstAccess = flags.firstAccess;
        let hasPuid = false;
        let acceptedGolTerms = false;

        if (isLoading) return;

        const getPartnerRedirectURL = async (inProduct: string, jwtToken: string) => {
          try {
            const ret = await getPartnerToken(inProduct);
            if (!ret.data || !ret.data.dataToken || !ret.data.dataToken.redirectLogin)
              return history.push('/validar/erro');
            let redirectLogin = ret.data.dataToken.redirectLogin;
            if (jwtToken && redirectLogin) {
              redirectLogin += `${redirectLogin.includes('?') ? '&' : '?'}st=${jwtToken}`;
            }
            return redirectLogin;
          } catch (e) {
            return history.push('/validar/erro');
          }
        };

        if (flagFirstAccess) {
          hasPuid = decoded?.['https://smiles.api/puid'];
          acceptedGolTerms = await getMemberGolTerms();
        }

        if (params.resendEmail) {
          try {
            const { success } = await generateTokenEmail();
            if (!success) {
              throw new Error();
            }
            history.push('/validar/reenvioemail');
          } catch {
            history.push('/validar/reenvioemail/erro');
          }
          return;
        }

        const isPartnerRedirect = partnerParams && partnerParams.product;
        if (!token && !isPartnerRedirect) {
          setOnFinishAnimation(() => {
            if (params.ref) {
              setOnFinishAnimation(() => {
                window.location.href = params.ref as string;
              });
              setAnimationState({ isSuccess: false, isLoading: false });
              return;
            }
            console.error('--------------------missing auth token--------------------');
            setOnFinishAnimation(() => {
              window.location.href = `${window.location.origin}/home?upd=${new Date().getTime()}`;
            });
          });
          setAnimationState({ isSuccess: false, isLoading: false });
          return;
        }

        if (token) {
          removeCookie(JWT_COOKIE_NAME);
        }

        if (decoded && decoded.scope && decoded.scope.includes('read:legalResp')) {
          return;
        }

        // liferay 6.2 login
        const errorLoginLF = await loginLiferay(token, decoded);
        if (errorLoginLF) {
          return;
        }
        
        // Redireciona para validar cenários de conta suspensa
        if (decoded) {
          const memberStatusToValidate = ['SUSPENDED', 'PVSM SUSPENDED', 'DECEASED', 'CANCELLED'];

          if (memberStatusToValidate.includes(apiMemberStatus)) {
            // check SR opened
            const suspended = {
              error: false,
              openedSR: false,
            };
            try {
              const { data } = await suspendedAccountHasSSR();
              suspended.openedSR = data?.openSSR ? data?.openSSR : false;
            } catch (error) {
              console.error(error);
              suspended.error = true;
            }

            setOnFinishAnimation(() => {
              let location = '/validar/erro';
              if (!suspended.error) {
                localStorage.setItem(JWT_COOKIE_NAME, token);
                location = suspended.openedSR ? '/validar/analise-conta-suspensa' : '/validar/conta-suspensa';
              }
              history.push(location);
            });
            setAnimationState({ isSuccess: !suspended.error, isLoading: false });
            return;
          }
        }


        if (decoded) {
          const reRegisterStatus = [
            'INCOMPL. REGISTRATION',
            'INCOMPL. REGISTRATION PARTNER',
            'PENDING ENROLLMENT',
            'PRE-REGISTRATION BANKS',
            'PRE REGISTRATION BANKS',
          ];
          if (reRegisterStatus.includes(apiMemberStatus)) {
            setOnFinishAnimation(() => {
              window.location.href = `${window.location.origin}/validar/recadastramento`;
            });
            setAnimationState({ isSuccess: true, isLoading: false });
            return;
          }
        }

        if (token && flagFirstAccess && (!hasPuid || !acceptedGolTerms)) {
          setOnFinishAnimation(async () => {
            redirectToFirstAccess();
          });
          setAnimationState({ isSuccess: true, isLoading: false });
          return;
        }

        if (token && flags.preRegister) {
          const isToConfirmMemberCobranded = await getMemberCobranded();
          if (isToConfirmMemberCobranded) {
            redirectToFirstAccess();
            setOnFinishAnimation(() => {
              redirectToFirstAccess();
            });
            setAnimationState({ isSuccess: true, isLoading: false });
            return;
          }
        }


        let redirectUrl = window.location.origin;
        if (isPartnerRedirect) {
          if (decodeURI(partnerParams.product as string).startsWith('/')) {
            redirectUrl = `${window.location.origin}${partnerParams.product}`;
          } else {
            // check if LF session is valid
            let jwtToken: string = localStorage.getItem(JWT_COOKIE_NAME) || '';
            if (jwtToken) {
              try {
                const resp = await Axios.get(
                  `https://${window.location.hostname}/${LiferayLoginConfig62.IS_LOGGED_ACTION}&token=${jwtToken}`,
                );
                if (resp.data.status === true) {
                  Config.saveTokenAuthUser({ accessToken: jwtToken });
                } else {
                  jwtToken = 'error';
                }
              } catch (e) {
                jwtToken = 'error';
              }
            }

            if (jwtToken === 'error') {
              jwtToken = '';
              localStorage.removeItem(JWT_COOKIE_NAME);
              sessionStorage.removeItem(JWT_COOKIE_NAME);
              Config.removeTokenAuthUser();
            }

            redirectUrl = await getPartnerRedirectURL(partnerParams.product, jwtToken);
            const url58Path = params._58_redirect as string;
            if (url58Path && url58Path.match(/https?:\/\/.*/g)) {
              if (redirectUrl && redirectUrl.includes('?')) {
                const qParams = redirectUrl.split('?')[1];
                if (url58Path.includes('?')) {
                  redirectUrl = `${url58Path}&${qParams}`;
                } else {
                  redirectUrl = `${url58Path}?${qParams}`;
                }
              } else if (redirectUrl) {
                redirectUrl = url58Path;
              }
            }
          }
          if (partnerParams.product && partnerParams.product.includes('dados-emissao')) {
            if (redirectUrl.includes('?')) {
              redirectUrl += '&loggedSearch=false';
            } else {
              redirectUrl += '?loggedSearch=false';
            }
          }

          setOnFinishAnimation(() => {
            if (!redirectUrl) return;
            window.location.href = redirectUrl;
          });
          setAnimationState({ isSuccess: true, isLoading: false });
          return;
        }

        if (params.ref) {
          redirectUrl = params.ref as string;
        }

        setOnFinishAnimation(() => {
          window.location.href = redirectUrl as string;
        });

        setAnimationState({ isSuccess: true, isLoading: false });
      } catch (e) {
        console.log('[catch useState]', e);
      }
    })();
  }, [partnerParams, isLoading]);

  useEffect(() => {
    const token = cookies[JWT_COOKIE_NAME];
    const loginEntryChannel = cookies[LOGIN_ENTRY_CHANNEL_COOKIE_NAME];
    const entryPhone = cookies[ENTRY_PHONE_COOKIE_NAME];
    const subEnv = cookies[SUB_ENV_COOKIE_NAME];
    let conversationId = cookies[CONV_ID_COOKIE_NAME];
    const userId = cookies[USER_ID_COOKIE_NAME];
    if (token) {
      const data = jwt.decode(token) as any;
      const memberNumber = data['https://smiles.api/memberNumber'];
      sessionStorage.setItem('memberStatus', data['https://smiles.api/memberStatus']);
      sessionStorage.setItem('memberNumber', memberNumber);
      localStorage.setItem('session-token-expiration', data.exp);
      if (
        conversationId &&
        userId &&
        loginEntryChannel === 'WhatsAppAtendimentoReceptivoSmiles' &&
        entryPhone &&
        subEnv
      ) {
        sendToLoginSunco(
          {
            token_jwt: token,
            conversation_id: conversationId,
            user_id: userId,
            whatsapp_receptivo_channel: loginEntryChannel,
            entry_phone: entryPhone,
          },
          subEnv,
          token,
        );
        conversationId = undefined;
        setTimeout(() => {
          window.location.replace(`https://wa.me/${entryPhone}`);
        }, 500);
      } else if (
        conversationId &&
        userId &&
        loginEntryChannel.includes('WhatsappReceptivoVoll') &&
        entryPhone &&
        subEnv
      ) {
        sendToLoginSunco(
          {
            token_jwt: token,
            conversation_id: conversationId,
            user_id: userId,
            whatsapp_receptivo_channel: loginEntryChannel,
            entry_phone: entryPhone,
          },
          subEnv,
          token,
        );
        console.log(`WhatsappReceptivoVoll login flow`);
        conversationId = undefined;
        setTimeout(() => {
          window.location.replace(`https://wa.me/${entryPhone}`);
        }, 500);
      }
      console.log(`[ LOG ] - scope ${JSON.stringify(data.scope)}`);

      if (params.ref && data.scope && data.scope.includes('read:legalResp')) {
        setTimeout(() => {
          sessionStorage.setItem('token-responsavel-legal', token);
          setOnFinishAnimation(() => {
            window.location.href = params.ref as string;
          });
          setMessage({
            error: [],
            loading: [t('one_moment'), t('lets_continue_register')],
            success: [t('one_moment'), t('lets_continue_register')],
          });
          setAnimationState({ isSuccess: true, isLoading: false });
          removeCookie(JWT_COOKIE_NAME);
        }, 100);
        return;
      }

      if (conversationId) {
        console.log('---- Entrou no fluxo da nova func');
        console.log(conversationId);
        sessionStorage.setItem('conversation-id', conversationId);
        const redisDataToSave = {
          id_conversation: conversationId,
          token,
        };
        sendToRedis(redisDataToSave);
        setTimeout(() => {
          removeCookie(CONV_ID_COOKIE_NAME);
          window.location.replace('https://wa.me/5511961720173');
        }, 500);
      }

      Config.saveTokenAuthUser({ accessToken: token });
      b2eFingerprint(memberNumber, 'SMILESLOGIN');
      b2eIdentity(memberNumber, 'SMILESLOGIN');
    }
  }, [cookies, params, partnerParams]);

  useEffect(() => {
    if (!partnerParams && params.ref && params.ref.includes('/cadastro/email')) {
      setMessage({ error: [], loading: [t('one_moment'), t('lets_continue_register')], success: [] });
    }
  }, [params, partnerParams]);

  return <SmlsAnimation currentState={animationState} onExit={onFinishAnimation} message={message} finishMode="yes" />;
};

export default Callback;
